import { Pipe, PipeTransform } from '@angular/core';
// take a zip code with ######### and add a hyphen before the last 4 digits ==> #####-####

@Pipe({
  name: 'zipCodeFormatter',
})
export class ZipCodeFormatterPipe implements PipeTransform {
  transform(value: any): string {
    if (!value) {
      return '';
    }

    if (value.length === 9) {
      value = value.replace(/(\d{5})(\d{4})/, '$1-$2');
    }

    return value;
  }
}
